import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

import ToolkitProvider from "react-bootstrap-table2-toolkit";

import signnameService from "../../services/signname.service";

import ModaladdUpload from "./ModaladdUploadSign";

import { Form } from "react-bootstrap";

//import Alert
import { toast } from "react-toastify";

import authService from "../../services/auth.service";

const user = authService.getCurrentUser();

function UploadSing() {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [item, setItem] = useState({
    active: "",
  });
  useEffect(() => {
    signnameService
      .getSignname()
      .then((result) => {
        setData(result.data);
      })
      .catch((err) => alert(err));
  }, []);

  const clickDeleteuser = (row) => {
    if (row.active) {
      toast.error("ไม่สามารถลบลายเซนต์ที่เลือกใช้งานอยู่ได้");
    } else {
      signnameService
        .deleteSignname(row.id)
        .then((response) => {
          setData((items) => items.filter((a) => a.id != response.data.id));
        })
        .catch((err) => toast.error(err));
    }
  };
  const ActionsEdit = (cell, row) => {
    console.log(cell);
    return (
      <>
        <i
          className="bi bi-trash custom-icon-table"
          style={{ color: "red" }}
          onClick={() => clickDeleteuser(row)}
        ></i>
      </>
    );
  };
  const handleInputChange = (event) => {
    event.preventDefault();
    signnameService
      .updateActive({ id: event.target.value, user_id: user.user.user_id })
      .then((response) => {
        setData((item) =>
          item.map((a) =>
            a.id == response.data.id
              ? { ...a, active: true }
              : { ...a, active: false }
          )
        );
        setItem({ ...item, [event.target.name]: response.data.id });
        toast.success("บันทึกข้อมูลเรียบร้อย");
      });
  };
  const checkActive = (cell, row) => {
    console.log(row);
    const { active } = item;
    console.log(active);
    return (
      <Form.Check
        value={row.id}
        type="radio"
        aria-label="radio 1"
        // label="Design"
        onChange={handleInputChange}
        checked={cell == true}
      />
    );
  };

  const columns = [
    {
      text: "id",
      dataField: "id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "sign_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "35%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ตำแหน่ง",
      dataField: "sign_position",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "35%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "รูป",
      dataField: "sign_picture",
      sort: true,
      editable: false,
      formatter: (cell) => {
        return (
          <img
            src={process.env.REACT_APP_API + "/images/forCard/" + cell}
            height="50px"
          ></img>
        );
      },
      headerStyle: () => {
        return { textAlign: "center", width: "20%", verticalAlign: "middle" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สถานะ",
      dataField: "active",
      sort: true,
      formatter: checkActive,
      searchable: false,
      // filter: textFilter({ placeholder: "ค้นหา Active, Disable" }),
      filterValue: (cell) => {
        if (cell === true) {
          return "Active";
        } else if (cell === false) {
          return "Disable";
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%", verticalAlign: "middle" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: ActionsEdit,
      headerStyle: () => {
        return { textAlign: "center", width: "10%", verticalAlign: "middle" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  return (
    <div>
      <ModaladdUpload
        show={show}
        hidden={setShow}
        data={data}
        setdata={setData}
      />{" "}
      <ToolkitProvider
        bootstrap4
        keyField="ID"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <div className="text-left">
                <button
                  className="btn btn-primary"
                  onClick={() => setShow(true)}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                >
                  เพิ่มลายเซนต์
                </button>
                {/* <SearchBar {...prop.searchProps} /> */}
              </div>
            </div>
            <hr />
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              cellEdit={false}
              filter={filterFactory()}
              {...prop.baseProps}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}
export default UploadSing;
